<script>

export default {
  methods: {
    dismiss () {
      this.$emit('dismiss')
    },
    logout () {
      this.$emit('logout')
    }
  }
}
</script>

<template>
  <div class="contain">
    <p class="title">Whether to log out ?</p>
    <p class="positive" @click="logout">Yes</p>
    <p class="negative" @click="dismiss">No</p>
  </div>
</template>

<style scoped>
.contain {
  width: 67.2rem;
  height: 26.7rem;
  align-self: center;
  border-radius: 1rem;
  display: flex;
  flex-flow: wrap;
  justify-content: space-around;
  background-image: url("@/assets/bg_logout.png");
  background-size: cover;
}

.title {
  width: 100%;
  color: #CCC0FF;
  font-size: 3.2rem;
  font-weight: 500;
  text-align: center;
  align-self: center;
  justify-self: center;
  line-height: 8rem;
}

.positive {
  color: white;
  font-size: 2.8rem;
  width: 27.1rem;
  height: 8.6rem;
  text-align: center;
  font-weight: 400;
  line-height: 6rem;
  background-image: url("@/assets/bg_logout_confirm.png");
  background-size: cover;
  justify-content: center;
  align-content: center;
  display: flex;
  justify-items: center;
  align-items: center;
}

.positive:active {
  opacity: 0.6;
}

.negative {
  color: white;
  font-size: 2.8rem;
  width: 27.1rem;
  height: 8.6rem;
  text-align: center;
  line-height: 6rem;
  font-weight: 400;
  background-image: url("@/assets/bg_logout_cancel.png");
  background-size: cover;
  justify-content: center;
  align-content: center;
  display: flex;
  justify-items: center;
  align-items: center;
}

.negative:active {
  opacity: 0.6;
}
</style>
